import React, { Component } from "react";
import { arrayOf, string, shape } from "prop-types";
import { connect } from "react-redux";

import { groupSelectors } from "reducers/administration";

import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";

class MembersList extends Component {
    static propTypes = {
        members: arrayOf(shape({ fullName: string, idUser: string })),
        adminUsers: arrayOf(string),
    };

    static defaultProps = {
        members: [],
        adminUsers: [],
    };

    render() {
        const { members, adminUsers } = this.props;

        if (!members.length) {
            return (
                <ul className="list pt-1">
                    <li>
                        <div className="list-item-inner">
                            <I18n componentProps={{ className: "f-size-4" }} id="administration.members.empty" />
                        </div>
                    </li>
                </ul>
            );
        }

        return (
            <ul className="list pt-1">
                {members.map(({ fullName, idUser }) => (
                    <li key={idUser} style={{ display: "inline-block" }}>
                        <div className="data-wrapper-flex">
                            <span className="data-desc gray-pill-group">{fullName}</span>
                            {adminUsers.includes(idUser) && (
                                <Image src="images/key.svg" className="svg-icon svg-caret mr-2" />
                            )}
                        </div>
                    </li>
                ))}
            </ul>
        );
    }
}

const mapStateToProps = (state) => ({
    members: groupSelectors.getMembers(state),
    adminUsers: groupSelectors.getAdminUsers(state),
});

export default connect(mapStateToProps)(MembersList);
